// extracted by mini-css-extract-plugin
module.exports = {"dogTagClanTag":"DogTagClanTag_dogTagClanTag_1kWkP","symbol":"DogTagClanTag_symbol_RoE_D","symbolImage":"DogTagClanTag_symbolImage_IZRWY"};